import React, { useMemo } from "react";

import { Table } from "semantic-ui-react";

import { useDictionary } from "hooks";

import { RateTypeHeader } from "./RateTypeHeader";
import { RateTypeRow } from "./RateTypeRow";
import styles from "./styles.css";


const RateTypeTable = ({ selectedRate }) => {
	const dateRanges = selectedRate?.dateRanges;
	const dictionary = useDictionary("budgetBuilder.components.RateTypeTable");

	const rateOrder = useMemo(() => {
		if (dateRanges && dateRanges.length > 0 && dateRanges[0]?.rates) {
			let nextIndex = 2;
			const rateOrder = {};
			const rates = dateRanges[0]?.rates;
			for (let rate of rates) {
				if (rate?.categoryName === "On Campus") {
					rateOrder[rate?.categoryId] = 0;
				} else if (rate?.categoryName === "Off Campus") {
					rateOrder[rate?.categoryId] = 1;
				} else {
					rateOrder[rate?.categoryId] = nextIndex;
					nextIndex++;
				}
			}

			return rateOrder;
		}

		return {};
	}, [ dateRanges ]);

	return (
		<Table className={styles.table}>
			<caption>Rate Type</caption>
			<Table.Header>
				<RateTypeHeader rateOrder={rateOrder} dateRanges={dateRanges} />
			</Table.Header>
			<Table.Body>
				{dateRanges?.sort((c, p) => rateOrder[c?.categoryId] - rateOrder[p?.categoryId])?.map((row, index) => (
					<RateTypeRow key={index} row={row} rateOrder={rateOrder} />
				))}
				{!dateRanges && (
					<Table.Row>
						<Table.Cell className={styles.noRates} colSpan={3}>
							{dictionary?.noRateSelected || "No rate type has been selected"}
						</Table.Cell>
					</Table.Row>
				)}
			</Table.Body>
		</Table>
	);
};

export default RateTypeTable;
